import { booleanDuckCreator } from '@atc/modular-redux';

const expiredPageMessageDuck = booleanDuckCreator({
    store: 'redirectPage',
});

export default expiredPageMessageDuck;
